export enum State {
  LOADING = 'loading',
  ERROR = 'error',
  SUCCESS = 'success',
}

export enum Env {
  DEV = 'development',
  PROD = 'production',
  TEST = 'test',
}

export type Meta = {
  id: string;
  createdAt: number;
  modifiedAt: number;
  createdBy: string;
  modifiedBy: string;
};

export type BaseAsset = {
  label: string;
  type: AssetType;
  shortid: string;
  markdown: string;
  image?: string;
  parent: string;
  order: string;
  tab: string;
};

type Contact = {
  id: number;
  type?: string;
  name?: string;
  phone?: string;
  email?: string;
};

export type Asset = Meta &
  BaseAsset & {
    contacts?: Contact[];
    attachments?: string[];
    file?: string;
  };

export enum AssetType {
  NEWS = 'news',
  JOINUS = 'blimedlem',
  COURSE = 'kurs',
  OFFERS = 'seiletilbud',
  INFO = 'info',
  LEIE = 'leie'
}

// TODO move from assets to news & pages
export type BaseNews = {
  published?: boolean;
  featured?: boolean;
}

export type News = Meta & BaseAsset & BaseNews

export type BasePage = {
  // TODO
}

export type BaseBooking = {
  firstName: string;
  surName: string;
  email: string;
  phone: string;
  type: string;
  details: string;
  acceptedTerms: boolean;
  dates: string[];
  approved?: boolean;
};

export type Booking = BaseBooking & Meta;

export type BaseCourse = {
  label: string;
  price: number;
  dates: string[];
  markdown: string;
  signupDeadline: string;
  location: string;
  completed?: boolean;
  maxSignups: number | null;
  image?: string;
  contact: string;
  published?: boolean;
  featured?: boolean;
  shortid: string;
  type?: string;
};

export type Course = BaseCourse & Meta;
